$(document).ready(function () {
    const consentCookieName = 'sor_cookie_consent';
    const banner = $('#cookieConsentBanner');
    const modal = $('#cookieConfigureModal');

    // Utility functions to manage cookies
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + encodeURIComponent(value || "") + expires + "; path=/";
    }

    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) {
                const val = c.substring(nameEQ.length, c.length);
                return decodeURIComponent(val);
            }
        }
        return null;
    }

    // Global helper for other scripts to check consent
    window.hasAnalyticsConsent = function () {
        const consent = getCookie(consentCookieName);
        if (!consent) return false;
        try {
            const preferences = JSON.parse(consent);
            return preferences.analytics === true;
        } catch (e) {
            return false;
        }
    };

    function updateGtagConsent(preferences) {
        if (typeof gtag === 'function') {
            gtag('consent', 'update', {
                'analytics_storage': preferences.analytics ? 'granted' : 'denied',
                'ad_storage': preferences.personalization ? 'granted' : 'denied',
                'ad_user_data': preferences.personalization ? 'granted' : 'denied',
                'ad_personalization': preferences.personalization ? 'granted' : 'denied',
                'personalization_storage': preferences.personalization ? 'granted' : 'denied',
                'functionality_storage': preferences.functionality ? 'granted' : 'denied'
            });
        }
    }

    // Check if consent has already been given
    const consent = getCookie(consentCookieName);

    if (!consent) {
        // Show banner if no consent

        // Reset checkboxes to default (unchecked) just in case the browser remembered them
        $('#cookieAnalytics').prop('checked', false);
        $('#cookieFunctionality').prop('checked', false);
        $('#cookiePersonalization').prop('checked', false);

        banner.show();
    } else {
        try {
            const preferences = JSON.parse(consent);

            // Set checkboxes based on saved preferences
            if (preferences.analytics !== undefined) $('#cookieAnalytics').prop('checked', preferences.analytics);
            if (preferences.functionality !== undefined) $('#cookieFunctionality').prop('checked', preferences.functionality);
            if (preferences.personalization !== undefined) $('#cookiePersonalization').prop('checked', preferences.personalization);

            if (!preferences.dismissed) {
                updateGtagConsent(preferences);
            }
        } catch (e) {
            console.error("Error parsing consent cookie", e);
        }
    }

    // "ACCEPT ALL" button click
    $('#cookieAcceptAllBtn').on('click', function () {
        const preferences = {
            necessary: true,
            analytics: true,
            functionality: true,
            personalization: true
        };
        setCookie(consentCookieName, JSON.stringify(preferences), 365);
        banner.hide();
        updateGtagConsent(preferences);
    });

    // Close banner icon click
    $('#cookieCloseBtn').on('click', function () {
        // Just hide the banner for this specific page view without saving consent.
        // It will reappear on the next page load or refresh.
        banner.hide();
    });

    // Configure button click
    $('#cookieConfigureBtn').on('click', function (e) {
        e.preventDefault();
        banner.hide();
        modal.show();
    });

    // Close modal icon click
    $('#cookieModalCloseBtn').on('click', function () {
        modal.hide();
        // Show banner again if no consent is saved
        if (!getCookie(consentCookieName)) {
            banner.show();
        }
    });

    // "SAVE PREFERENCES" button click
    $('#cookieSavePreferencesBtn').on('click', function () {
        const preferences = {
            necessary: true,
            analytics: $('#cookieAnalytics').is(':checked'),
            functionality: $('#cookieFunctionality').is(':checked'),
            personalization: $('#cookiePersonalization').is(':checked')
        };
        setCookie(consentCookieName, JSON.stringify(preferences), 365);
        modal.hide();
        banner.hide();

        updateGtagConsent(preferences);
    });
});
